import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface EditPrimerOptionsProps {
  single: boolean;
}

function EditPrimerOptions({single}: EditPrimerOptionsProps): JSX.Element {
  return (
    <ul className="nav navbar-nav">
      <li>
        <select>
          <option value="1">Single Primer</option>
          <option value="2">Primer Pair</option>
        </select>
      </li>
      <li className="pull-right">
        <div className="buttonGroup">
          {single ? (
            <Button
              buttonStyle={ButtonStyle.TERTIARY_GRAY}
              size={ButtonSize.MINI}
              className="js-jump"
              text="Jump to Primer"
            />
          ) : (
            <div className="buttonGroup">
              <Button
                buttonStyle={ButtonStyle.TERTIARY_GRAY}
                size={ButtonSize.MINI}
                type="button"
                isDropdown={true}
                text="Jump to Primer"
              />
              <ul className="dropdown-menu pull-right">
                <li>
                  <a className="js-jump">Forward</a>
                </li>
                <li>
                  <a className="js-jump-reverse">Reverse</a>
                </li>
              </ul>
            </div>
          )}
          <div className="buttonGroup">
            <Button
              buttonStyle={ButtonStyle.SECONDARY}
              size={ButtonSize.MINI}
              type="button"
              isDropdown={true}
              text="Set from Selection"
            />
            <ul className="dropdown-menu pull-right">
              <li className="js-read-selection-forward">
                <a>Forward</a>
              </li>
              <li className="js-read-selection-reverse">
                <a>Reverse</a>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  );
}

export default makeDeprecatedJadeStyleTemplate<EditPrimerOptionsProps>(EditPrimerOptions);
